import { Accordion as BaseAccordion } from "@base-ui/react/accordion";
import { LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import Card, { CardContent, CardHeader, CardVariant } from "@/components/frontend/ui/card";

interface AccordionItemProps {
	children: React.ReactNode;
	title: string;
	Icon: LucideIcon;
	cardVariant?: CardVariant;
}

/**
 * Individual accordion item component with question and answer.
 *
 * @param children - The answer content to display when expanded.
 * @param title - The question text displayed in the trigger.
 * @param Icon - The icon component to display (typically ChevronDown).
 * @param cardVariant - Optional card variant used to wrap the item.
 */
export const AccordionItem: React.FC<AccordionItemProps> = ({ children, Icon, title, cardVariant = "default" }) => {
	const triggerClassName = "flex items-center justify-between w-full text-left transition-colors";

	return (
		<Card variant={cardVariant} className="ms-card-with-hover">
			<BaseAccordion.Item className="ms-accordion-item">
				<CardHeader className="w-full">
					<BaseAccordion.Trigger className={cn("group cursor-pointer", triggerClassName)}>
						<span>{title}</span>
						<Icon className="w-5 h-5 transition-transform group-data-panel-open:rotate-180 shrink-0 ml-4" />
					</BaseAccordion.Trigger>
				</CardHeader>
				<BaseAccordion.Panel className="h-(--accordion-panel-height) overflow-hidden transition-[height] ease-out data-ending-style:h-0 data-starting-style:h-0">
					<CardContent>{children}</CardContent>
				</BaseAccordion.Panel>
			</BaseAccordion.Item>
		</Card>
	);
};
